import { FaApple, FaGoogle } from 'react-icons/fa';

export default function FormSocial() {
  const isOnEarly = window.location.hostname.includes('onearly');
  return (
    <div className="">
      <div className="relative">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-gray-200" />
        </div>
        <div className="relative flex justify-center text-sm font-medium leading-6 py-4">
          <span className="bg-white px-2 text-gray-500">OR</span>
        </div>
      </div>
      <div className="flex flex-row justify-center align-center gap-2">
        {isOnEarly && (
          <a
            className="justify-center justify-items-center flex border border-gray-200 rounded-md p-4"
            href={`/auth/apple${window.location.search}`}
          >
            <FaApple />
          </a>
        )}
        <a
          className="justify-center justify-items-center flex border border-gray-200 rounded-md p-4"
          href={`/auth/google${window.location.search}`}
        >
          <FaGoogle />
        </a>
      </div>
    </div>
  );
}
